import attackData from "../../data/attacks.json" with { type: "json" };
import { SDPS } from "../../data/sdps.js";
import { panelTokens } from "@csk/demo-ui";

export interface AttackPattern {
  readonly id: string;
  readonly title: string;
  readonly generator: string;
  readonly seam: string;
  readonly sdp: string;
  readonly forbiddenPhantom: string;
  readonly gradedRefusal: string;
  readonly refusedBy: readonly string[];
}

export interface AttackScenario {
  readonly id: string;
  readonly title: string;
  readonly patternId: string;
  readonly sdp: string;
  readonly story: string;
  readonly adversary: string;
  readonly binaryView: string;
  readonly gradedRefusal: string;
  readonly expectedGrade: string;
  readonly presentedGrade: string;
  readonly verdict: string;
  readonly verdictBy: string;
  readonly aiPayoff: string;
}

export type SelectionMode = "pattern" | "scenario";

export interface Selection {
  readonly mode: SelectionMode;
  readonly id: string;
}

export const PATTERNS: readonly AttackPattern[] = attackData.patterns;
export const SCENARIOS: readonly AttackScenario[] = attackData.scenarios;

export const DEFAULT_PATTERN_ID = PATTERNS[0]?.id ?? "CD-1";

export const PATTERN_BY_ID: ReadonlyMap<string, AttackPattern> = new Map(
  PATTERNS.map((pattern) => [pattern.id, pattern]),
);

export const SCENARIO_BY_ID: ReadonlyMap<string, AttackScenario> = new Map(
  SCENARIOS.map((scenario) => [scenario.id, scenario]),
);

const SDP_COLOR_BY_CODE: ReadonlyMap<string, string> = new Map(
  SDPS.map((sdp) => [sdp.code, sdp.color]),
);

const SDP_NAME_BY_CODE: ReadonlyMap<string, string> = new Map(
  SDPS.map((sdp) => [sdp.code, sdp.name]),
);

export function colorForSdp(sdp: string, fallback = panelTokens.accent): string {
  return SDP_COLOR_BY_CODE.get(sdp) ?? fallback;
}

export function nameForSdp(sdp: string): string {
  return SDP_NAME_BY_CODE.get(sdp) ?? "-";
}

export const PATTERN_CHIPS = PATTERNS.map((pattern) => ({
  id: pattern.id,
  label: `${pattern.id} · ${pattern.title.split(" — ")[0] ?? pattern.title}`,
  color: colorForSdp(pattern.sdp, panelTokens.accentRed),
}));

export const SCENARIO_CHIPS = SCENARIOS.map((scenario) => ({
  id: scenario.id,
  label: scenario.title.split(" (")[0] ?? scenario.title,
  color: colorForSdp(scenario.sdp, panelTokens.accentCyan),
}));

export const RED = "#ef4444";
export const GREEN = "#22c55e";
